import { render, staticRenderFns } from "./PostAssemble.vue?vue&type=template&id=4674c2a4&scoped=true"
import script from "./PostAssemble.vue?vue&type=script&lang=js"
export * from "./PostAssemble.vue?vue&type=script&lang=js"
import style0 from "./PostAssemble.vue?vue&type=style&index=0&id=4674c2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4674c2a4",
  null
  
)

export default component.exports